import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
export var InlineLink = function InlineLink(props) {
  return React.createElement(AppLink, {
    href: props.decoratedText,
    target: "_blank",
    rel: "nofollow"
  }, props.children);
};